import { IDiscussionGuideQuestion } from './data-capture.models';

export interface IDiscussionGuideUploadJobCreateLogs {
  /** postgresql timestamp  */
  created_at: string;
  /** uuid */
  created_by: string;
}

export enum DiscussionGuideUploadJobStatus {
  Complete = 'complete',
  Failed = 'failed',
}

export interface IDiscussionGuideUploadJob {
  discussion_guide_id: string;
  sheet_id: string;
  status: DiscussionGuideUploadJobStatus;
  guide_key: string;
  discussion_guide_questions: IDiscussionGuideQuestion[];
}

export type DiscussionGuideUploadJob = IDiscussionGuideUploadJob &
  IDiscussionGuideUploadJobCreateLogs;
